import { connect } from 'react-redux'
import React from 'react'
import { notifyOffline } from '../offline/actions.js'
import { isOffline } from '../offline/reducer.js'

const OfflineBanner = ({ offline }) => offline ? (
  <div className='ncss-container bg-accent mb2-sm offline-section text-color-primary-light u-align-center'>
    <span className='fs20-sm u-sm-ib pr4-sm pl4-sm'>
      <i className='g72-alert' />
    </span>
    <span className='ncss-brand'>OFFLINE MODE</span>
    <span className='pl2-sm'>functionality may be limited</span>
  </div>
) : null

export default connect(state => ({
  offline: isOffline(state)
}), { notifyOffline })(OfflineBanner)



// WEBPACK FOOTER //
// ./client/src/offline/offline.js